import React, { useState, useEffect } from "react";

export interface CountyNotice {
  title: string;
  contentHtml: string;
  requireAcknowledgment: boolean;
  triggerStep: string;
}

interface CountyNoticeCardProps {
  notices: CountyNotice[];
  onContinue: () => void;
  onBack?: () => void;
}

const CountyNoticeCard: React.FC<CountyNoticeCardProps> = ({ notices, onContinue, onBack }) => {
  const [acceptedNotices, setAcceptedNotices] = useState<Record<number, boolean>>({});

  useEffect(() => {
    const initialAcc: Record<number, boolean> = {};
    notices.forEach((notice, i) => {
      if (!notice.requireAcknowledgment) {
        initialAcc[i] = true;
      } else {
        initialAcc[i] = false;
      }
    });
    setAcceptedNotices(initialAcc);
  }, [notices]);

  const toggleAccept = (index: number) => {
    setAcceptedNotices(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const allAccepted = notices.every((notice, i) => 
    !notice.requireAcknowledgment || acceptedNotices[i]
  );

  return (
    <>
      <div className="w-full flex flex-col gap-6 mb-8">
        {notices.map((notice, index) => (
          <div key={index} className="flex flex-col gap-4">
            <div className="text-[18px] font-plus-jakarta font-semibold text-[#141435]">
              {notice.title || "Official County Notice"}
            </div>
            <div 
              className="w-full bg-[#F9FAFB] rounded-lg p-6 text-[#485D7D] text-sm leading-relaxed overflow-y-auto"
              style={{ maxHeight: 300 }}
              dangerouslySetInnerHTML={{ __html: notice.contentHtml || "" }}
            />
            {notice.requireAcknowledgment && (
              <div className="flex items-center w-full">
                <input
                  id={`notice-accept-${index}`}
                  type="checkbox"
                  checked={!!acceptedNotices[index]}
                  onChange={() => toggleAccept(index)}
                  className="mr-2 w-5 h-5 accent-[#0B4BB6]"
                />
                <label htmlFor={`notice-accept-${index}`} className="text-[#485D7D] text-sm select-none">
                  I acknowledge and accept the terms of this notice.
                </label>
              </div>
            )}
          </div>
        ))}
      </div>
      
      <div className="flex flex-row w-full gap-4">
        {onBack && (
          <button
            type="button"
            className="flex-1 bg-[#7C8B9D] text-white font-plus-jakarta font-bold py-2.5 px-5 rounded-full hover:bg-[#485D7D] transition-colors"
            onClick={onBack}
          >
            Back
          </button>
        )}
        <button
          type="button"
          className={`flex-1 bg-[#0B4BB6] text-white font-plus-jakarta font-bold py-2.5 px-5 rounded-full transition-colors ${!allAccepted ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#23235a]'}`}
          disabled={!allAccepted}
          onClick={onContinue}
        >
          Acknowledge & Continue
        </button>
      </div>
    </>
  );
};

export default CountyNoticeCard;
